<template>
  <div
    class="w-100 pt-2 pb-2"
    :class="{ opened: expanded }"
  >
    <div
      class="w-100 d-flex justify-space-between"
      :class="{ 'cursor-pointer': expandable }"
      @click="onExpandClick"
    >
      <div class="d-flex">
        <v-sheet
          v-if="showIcon"
          class="mr-2 d-flex flex-column justify-center"
          height="20"
        >
          <v-icon
            class="my-auto"
            icon="material-symbols:check-circle"
            size="16"
            color="success"
          />
        </v-sheet>

        <div
          class="text-body-2 d-flex flex-column justify-center"
          :class="[expanded ? 'text-textDarkest' : 'text-textLight']"
        >
          <DpplSafeHtml :html="message.tooltip_short" />
        </div>
      </div>

      <div>
        <slot
          name="append-icon"
          v-bind="{ message }"
        />
        <v-icon
          v-if="expandable"
          class="ml-2"
          :icon="expanded ? '$minus' : '$plus'"
          color="iconDefault"
          size="20"
        />
      </div>
    </div>

    <div
      v-if="expanded"
      class="mt-1 text-body-3 text-textLight"
    >
      {{ message.tooltip_long }}

      <div
        v-if="message.read_more_url || showOneClickAdd || showApplyTemplateAction || message.action.startsWith('custom')"
        class="mt-1 d-flex ga-2 flex-wrap"
      >
        <div v-if="!hideActions && showOneClickAdd">
          <v-btn
            height="20"
            color="primary"
            rounded="lg"
            variant="outlined"
            size="small"
            @click="$emit('add', message.hash)"
          >
            Add
          </v-btn>
        </div>

        <div v-if="!hideActions && showApplyTemplateAction">
          <v-btn
            height="20"
            color="primary"
            rounded="lg"
            variant="outlined"
            size="small"
            @click="onActionClick"
          >
            Apply Template
          </v-btn>
        </div>

        <slot
          name="custom-action"
          v-bind="{ message }"
        />

        <v-spacer />

        <div
          v-if="message.read_more_url"
        >
          <a
            :href="message.read_more_url"
            target="_blank"
            rel="noopener noreferrer"
          >
            <v-btn
              height="20"
              color="primary"
              rounded="lg"
              variant="text"
              size="small"
              class="px-0"
              @click="$emit('track-sidebar-event', { action: 'Sidebar Read More Clicked' })"
            >
              Learn more
            </v-btn>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import DpplSafeHtml from '@ui/components/general/DpplSafeHtml/DpplSafeHtml.vue';

export default {
  name: 'GuidanceMessage',
  components: { DpplSafeHtml },

  props: {
    message: { type: Object, default: () => ({}) },
    showIcon: { type: Boolean, default: false },
    hideActions: { type: Boolean, default: false },
  },

  emits: ['add', 'track-sidebar-event', 'show-apply-template'],

  data() {
    return {
      expanded: this.message.initiallyOpen ?? false,
    };
  },

  computed: {
    expandable() {
      return this.message.tooltip_long?.length > 0;
    },

    hasSuggestions() {
      return this.message.suggestions.length > 0;
    },

    showOneClickAdd() {
      return this.hasSuggestions
        && ['red-solid', 'blue-solid', 'yellow-solid'].includes(this.message.severity_class);
    },

    showApplyTemplateAction() {
      // 102 - Incorrect Template Content
      // 103 - No Template Content
      return [102, 103].includes(this.message.child_category_id);
    },

    trackArgs() {
      return {
        short: this.message.tooltip_short,
        severityClass: this.message.severity_class,
        long: this.message.tooltip_long,
        categoryId: this.message.category_id,
        childCategoryId: this.message.child_category_id,
        ruleId: this.message.ruleId,
      };
    },
  },

  methods: {
    onActionClick() {
      if (this.showApplyTemplateAction) {
        this.$emit('track-sidebar-event', {
          action: 'sidebar-show-template', args: this.trackArgs,
        });
        this.$emit('show-apply-template');
      }
    },

    onExpandClick() {
      if (!this.expandable) {
        return;
      }

      this.expanded = !this.expanded;

      if (this.expanded) {
        this.$emit('track-sidebar-event', { action: 'sidebar-expand', args: this.trackArgs });
      }
    },
  },
};
</script>
